// extracted by mini-css-extract-plugin
export default {"qm-feedback-overview-tab-grid-container":"quality-management-feedback-overview-tab---fac83c03"};